<template>
  <div class="eva-chat-bar">
    <div class="eva-chat-bar-inner eva-chat-bar-inner--column">
      <div class="eva-chat-bar-row">
        <!-- Input de pregunta -->
        <input
          v-model="localQuestion"
          placeholder="Haz tu pregunta aquí."
          @keyup.enter="onSend"
          :disabled="loading"
          class="eva-chat-input"
          autocomplete="off"
          type="text"
        />
        <!-- Botón enviar -->
        <button
          class="eva-send-btn"
          :disabled="loading || !localQuestion.trim()"
          @click="onSend"
          type="button"
        >
          <feather-icon
            icon="ArrowUpCircleIcon"
            size="30"
            :class="['color-icon', (loading || !localQuestion.trim()) ? 'opacity-50 cursor-no-drop' : 'cursor-pointer']"
          />
        </button>
      </div>
      <!-- Selector de país debajo del input -->
      <div class="d-flex align-items-center">
        <div class="eva-country-select--bottom" v-if="isAdmin">
          <v-select
            v-if="countryOptions.length"
            v-model="localCountry"
            :options="countryOptions"
            :disabled="true"
            :clearable="false"
            :searchable="false"
            class="eva-country-select"
          >
            <!-- Opciones del desplegable -->
            <template #option="{ name, code }">
              <img
                class="reduce-flag"
                :src="require(`@/assets/images/flags/${code.toLowerCase()}.png`)"
                :alt="`Bandera de ${name}`"
              />
            </template>

            <!-- Valor seleccionado -->
            <template #selected-option="{ name, code }">
              <img
                class="reduce-flag"
                :src="require(`@/assets/images/flags/${code.toLowerCase()}.png`)"
                :alt="`Bandera de ${name}`"
              />
            </template>
          </v-select>
        </div>
        <button v-if="messages.length" :class="[activeQuestion ? 'eva-chat-bar-questions-active' : 'eva-chat-bar-questions']" @click="questions" :disabled="loading">
          ? Preguntas
        </button>
      </div>
    </div>
    <div class="eva-chat-bar-msg">EVA puede cometer errores. Valida la información con tu ejecutivo/a antes de tomar decisiones operativas.</div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: { vSelect },
  name: 'EvaChatBar',
  props: {
    value: { type: String, default: '' },
    country: { type: [Object], default: null },
    countryOptions: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    activeQuestion: { type: Boolean, default: false },
    messages: { type: Array, default: () => [] },
    mySession: { type: Object, default: () => {} }
  },
  data () {
    return {
      localQuestion: this.value || '',
      localCountry : this.country ? this.country : null
    }
  },
  computed: {
    isAdmin () {
      return this.mySession.role === 'admin'
    }
  },
  watch: {
    // ① Mantener sincronizado el texto de la pregunta
    value (val) { this.localQuestion = val },
    localQuestion (val) { this.$emit('input', val) },

    // ② Cuando el usuario cambie el select, enviamos el objeto completo
    localCountry (obj) {
      this.$emit('update:country', obj || null)
    },

    // ③ Cuando las opciones lleguen por primera vez, autoseleccionar Chile
    countryOptions: {
      immediate: true,
      handler (opts) {
        if (!this.localCountry && opts.length) {
          const chile = opts.find(c =>
            c.code === 'cl' || c.name?.toLowerCase() === 'chile')
          if (chile) this.localCountry = chile
        }
      }
    }
  },
  methods: {
    onSend () {
      if (!this.loading && this.localQuestion.trim()) {
        this.$emit('send', this.localQuestion)
      }
    },
    questions () {
      this.$emit('activateQuestions', !this.activeQuestion)
    }
  }
}
</script>

<style lang="scss">
.eva-chat-bar {
  border: none !important;
}
.eva-chat-bar-inner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 30px;
  border: 2px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box,
              linear-gradient(90deg, #32ADEC 0%, #685FE3 100%) border-box;
  padding: 8px 12px;
  gap: 4px;
  position: relative;
}
.eva-chat-bar-inner--column {
  flex-direction: column;
}
.eva-chat-bar-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
}
.eva-country-select--bottom {
  width: 5rem;
  align-items: center;
  ul {
    min-width: 7rem;
  }
  div {
    border: none;
  }
}
.eva-chat-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 1rem;
  padding: 8px 0 8px 0;
  min-width: 0;
  height: 40px;
  background-color: #fff;
}
.eva-chat-input:disabled {
  opacity: 0.5;
  background-color: #fff;
  cursor: no-drop;
}
.eva-send-btn {
  background: none;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-left: 4px;
  transition: background 0.2s;
  cursor: pointer;
}
.eva-send-btn:disabled {
  opacity: 0.5;
  cursor: no-drop;
}
.reduce-flag{
  width: 1.5rem;
}
.color-icon {
  color: #32ADEC;
}
.eva-country-select .vs__dropdown-menu {
  top: auto !important;
  bottom: 100% !important;
  margin-bottom: 4px; /* Espacio opcional */
}
.eva-chat-bar-msg {
  font-size: 14px;
  color: rgba(110, 107, 123, 1);
  text-align: center;
  margin-top: 0.5rem;
  opacity: 0.5;
}
.eva-chat-bar-questions-active {
  display: flex;
  color: #fff;
  background: linear-gradient(90deg, #32ADEC 0%, #685FE3 100%) border-box;
  border-radius: 10px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 0.5rem;
  border: 1.5px solid transparent;
}
.eva-chat-bar-questions {
  background: linear-gradient(#fff, #fff) padding-box,
              linear-gradient(90deg, #32ADEC 0%, #685FE3 100%) border-box;
  color: #32ADEC;
  border-radius: 10px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 0.5rem;
  border: 1.5px solid transparent;
  background-clip: padding-box, border-box;
  box-shadow: 0 0 0 1.5px #fff inset;
}
.eva-chat-bar-questions:disabled {
  opacity: 0.5;
  cursor: no-drop;
  background-color: #fff !important;
}
</style>
